module.exports = __webpack_public_path__ + "img/benefits-slider-0.2c5732f8.png";